module.exports = __webpack_public_path__ + "media/images/system-branding-aadaa1984dd2e0b7cead602a6b3df404.png";